import { ReactNode } from "react";
import s from "./public.module.scss";

/**
 * Option 4 (board 339, v5 boards 340-358): the last words of a headline carry the logo gradient (blue -> teal). Every public heading is large
 * text (30px bold card titles, 44px+ taglines and the home headline), so the gradient's lightest end (3.7:1) is allowed on all of them; v5 never
 * uses a flat blue for key words. The words are today's, only split. `large` is kept so older callers compile; it no longer changes the colour.
 */
export const keyWords = (text: ReactNode, _large = false): ReactNode => { // eslint-disable-line @typescript-eslint/no-unused-vars
  if (typeof text !== "string" || !text.trim()) return text;
  const w = text.trim().split(/\s+/);
  const n = w.length === 1 ? 1 : w.length <= 3 ? 1 : 2;
  const head = w.slice(0, w.length - n).join(" ");
  return <>{head}{head ? " " : ""}<span className={s.keyLarge} data-key-words="">{w.slice(w.length - n).join(" ")}</span></>;
};
